import React from "react";
import EPubForm from "./components/EPubForm";

const EPubFormContainer = () => {
    return <EPubForm />
}

export default EPubFormContainer;